import { useNotificationContext } from '@modules/common/components/Notification/NotificationContext';
import {
  ListAnalysesInput,
  ListAnalysesResponse,
  useListAnalysesQuery,
} from 'generated/graphql';
import { apolloStatusToQueryStatus } from 'v2/core/repository/edge-server/statusConvertor';
import { Response } from 'v2/core/services/types';

export const useFetchAnalyses = ({
  input,
}: {
  input: ListAnalysesInput;
}): Response<ListAnalysesResponse> => {
  const { showErrorNotification } = useNotificationContext();

  const { data, error, loading, called } = useListAnalysesQuery({
    variables: {
      request: input,
    },
    fetchPolicy: 'cache-and-network',
    onError: () => {
      showErrorNotification({
        contentComponent: 'Failed to fetch analyses',
        props: {},
      });
    },
  });

  const analyses = data?.listAnalyses;

  const analysisStatus = apolloStatusToQueryStatus(
    loading,
    called,
    false,
    error,
  );

  return {
    data: analyses,
    status: analysisStatus,
  };
};
